export const BASE_URL = process.env.REACT_APP_API_BASE_URL
export const TAMIN_DRUG_SEARCH_BASE_URL = process.env.REACT_APP_TAMIN_DRUG_SERCH_BASE_URL
export const Automation_BASE_URL = process.env.REACT_APP_AUTOMATION_BASE_URL
export const ScannerUrl='http://localhost:8090/GetScan2'